export const DOWNLOAD_REPORT_REQUEST = 'DOWNLOAD_REPORT_REQUEST';

export const downloadReportRequest = ( id ) => ({
    type: DOWNLOAD_REPORT_REQUEST,
    payload: { id }
});
